<ph-alert *ngIf="summary; else panel" status="success" variant="lighter" size="small">
    <div>{{ effectText }}</div>
    <div *ngIf="section.amount">{{ section.amount }}</div>
</ph-alert>
<ng-template #panel>
    <ph-card flat [heading]="section.label">
        <ph-badge slot="actions" *ngIf="confidenceLabel as label" variant="light" size="small" [color]="confidence === 'high' ? 'green' : confidence === 'low' ? 'red' : 'blue'">{{ label }}</ph-badge>
        <ph-stack gap="tight">
            <div>{{ effectText }}</div>
            <ph-hint *ngIf="section.amount">{{ section.amount }}</ph-hint>
        </ph-stack>
    </ph-card>
</ng-template>
